import { withStyles } from '@material-ui/styles';
import InvoicesTable from './InvoicesTable';
import styles from './styles';

export default withStyles(styles)(InvoicesTable);
